import React, { forwardRef, HTMLAttributes } from "react";
import classNames from "classnames";

export type HandleProps = HTMLAttributes<HTMLDivElement>;

export const Handle = forwardRef<HTMLDivElement, HandleProps>(({ className, ...rest }, ref) => {
  return (
    <div
      {...rest}
      ref={ref}
      className={classNames("ui-bottom-sheet-dialog-handle", className)}
      aria-hidden="true"
    />
  );
});

Handle.displayName = "BottomSheet.Handle";
